module.exports = __webpack_public_path__ + "static/media/drivers.10a88b12.jpg";